import { useMemo } from 'react';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { apiInstance } from '../../../../context/api';

interface LookupItem {
  id: number | null;
  name: string;
}

export function useAccountsLookupStore(pageSize = 10) {
  const store = useMemo(
    () =>
      new CustomStore<LookupItem>({
        key: 'id',
        load: async ({ skip = 0, take = pageSize, searchValue }) => {
          const page = skip / take + 1;
          const params: Record<string, any> = {
            items_per_page: take,
            page,
            sort: 'name',
          };
          if (searchValue) {
            params.name = searchValue;
          }

          const response: {
            status: string;
            count_companies: number;
            companies_list: LookupItem[];
          } = await apiInstance.get('/companies/shortList', { params });

          if (page === 1 && !searchValue) {
            response.companies_list.unshift({ id: null, name: 'Not selected' })
          }

          return {
            data: response.companies_list,
            totalCount: response.count_companies,
          };
        },
        byKey: async (key: number) => {
          // return new Promise(resolve => resolve({ id: 0, name: 'Select account...' }))
          const response: {
            status: string;
            company_info: { id: number, name: string }
          } = await apiInstance.get(`/companies/edit/${key}`);

          return { id: response.company_info.id, name: response.company_info.name };
        }
      }),
    [pageSize]
  );

  return store
}
